module.exports = __webpack_public_path__ + "static/media/frameshop_2.9dcd6f51.jpg";